import { Injectable, ViewContainerRef } from "@angular/core";
import {
  ConfirmDialogParams,
  ConfirmDialogComponent,
} from "../shared/components/confirm-dialog/confirm-dialog.component";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import {
  AlertDialogParams,
  AlertDialogComponent,
} from "../shared/components/alert-dialog/alert-dialog.component";
import { ComponentType } from "@angular/cdk/portal";
import {
  DynamicDialogComponent,
  DynamicDialogParams,
} from "../shared/components/dynamic-dialog/dynamic-dialog.component";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  customDialog<T>(
    dialogType: ComponentType<T>,
    data: any,
    disableClose: boolean = false,
    panelClass?: string,
    vcr?: ViewContainerRef
  ) {
    const dialogConfig = new MatDialogConfig<any>();
    dialogConfig.disableClose = disableClose;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = panelClass || "custom-dialog";
    dialogConfig.width = panelClass ? null : "800px";
    dialogConfig.height = "fit-content";
    dialogConfig.data = data;
    dialogConfig.viewContainerRef = vcr;

    return this.dialog.open(dialogType, dialogConfig);
  }

  confirmDialog(dialogParams: ConfirmDialogParams) {
    const dialogConfig = new MatDialogConfig<ConfirmDialogParams>();
    dialogConfig.disableClose = dialogParams.disableClose;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = dialogParams.autoFocus ?? true;
    dialogConfig.panelClass = dialogParams.panelClass || "confirm-dialog";
    dialogConfig.width = dialogParams.panelClass ? null : "600px";
    dialogConfig.data = dialogParams;
    dialogConfig.viewContainerRef = dialogParams.vcr;

    return this.dialog.open(ConfirmDialogComponent, dialogConfig);
  }

  alertDialog(dialogParams: AlertDialogParams) {
    const dialogConfig = new MatDialogConfig<AlertDialogParams>();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = dialogParams.autoFocus ?? true;
    dialogConfig.panelClass = dialogParams.panelClass || "alert-dialog";
    dialogConfig.width = dialogParams.panelClass ? null : "600px";
    dialogConfig.data = dialogParams;
    dialogConfig.backdropClass = dialogParams.backdropClass || "";

    return this.dialog.open(AlertDialogComponent, dialogConfig);
  }

  dynamicDialog(dialogParams: DynamicDialogParams) {
    const dialogConfig = new MatDialogConfig<DynamicDialogParams>();
    dialogConfig.disableClose = dialogParams.disableClose;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = dialogParams.autoFocus ?? true;
    dialogConfig.panelClass = dialogParams.panelClass || "dynamic-dialog";
    dialogConfig.width = dialogParams.panelClass ? null : "600px";
    dialogConfig.data = dialogParams;
    dialogConfig.viewContainerRef = dialogParams.vcr;

    return this.dialog.open(DynamicDialogComponent, dialogConfig);
  }
}
